import brBR from 'antd/lib/locale/pt_BR';
import enUS from 'antd/lib/locale/en_US';
import esES from 'antd/lib/locale/es_ES';

export const resolveAntdLocale = (language: string) => {
  switch (language) {
    case 'en':
      return enUS;
    case 'es':
      return esES;
    default:
      return brBR;
  }
};
